import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MenuItem } from './menu-item';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SideNavComponent implements OnInit {
  menuItems: MenuItem[] = [];
  public settings: Settings;
  
  constructor(
    private route: ActivatedRoute,
    private appSettings: AppSettings, 
  ) { 
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    this.menuItems = this.route.snapshot.data.navMenu;    
  }
  
  public editExpanded(changingItem){
    if(changingItem.children.length > 0){
      this.menuItems.forEach(item =>{
        if(item == changingItem){
          item.isExpanded = !item.isExpanded;
        }else{
          item.isExpanded = false;
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/menu/side-nav/side-nav.component.ts